import { render, staticRenderFns } from "./CanteenSearchLanding.vue?vue&type=template&id=6b663529&"
import script from "./CanteenSearchLanding.vue?vue&type=script&lang=js&"
export * from "./CanteenSearchLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports